import { render, staticRenderFns } from "./ModalActivateParticipant.vue?vue&type=template&id=b383e5c8&scoped=true&"
import script from "./ModalActivateParticipant.vue?vue&type=script&lang=js&"
export * from "./ModalActivateParticipant.vue?vue&type=script&lang=js&"
import style0 from "./ModalActivateParticipant.vue?vue&type=style&index=0&id=b383e5c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b383e5c8",
  null
  
)

export default component.exports